import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { DocMetadata, DocMetadataGroup, DocMetadataInfo, EntityType } from "./model/doc-metadata";
import { DocMetadataHandler } from "./services/add-doc-metadata.interface";
import { newCatSystemVersion} from "@shared/models/common";

@Component({
    selector: 'add-doc-metadata',
    templateUrl: './add-doc-metadata.component.html',
    styleUrls: ['./add-doc-metadata.component.scss'],
    standalone: false
})
export class AddDocMetadataComponent implements OnInit, OnChanges {
        
    @Input({ required: true }) docMetadataHandler!: DocMetadataHandler;
    @Input() envId!: number;
    @Input() lang!: string;
    @Input() catVersionId!: number;
    @Input() catSystemVersion!: number;
    @Input() assetType: string | null = null;
    @Input() entityType!: EntityType;
    @Input() readonly: boolean = false
    @Output() initializedMetadataGroups = new EventEmitter();
    groups: DocMetadataGroup[] | null= null;

    newCatSystemVersion = newCatSystemVersion;
    
    docMetadataByGroup: {[group: string]: DocMetadata[]} | null = null;

    ngOnInit(): void {
        
/*         // loading
       this.docMetadataHandler.getDocMetadataDefinition(this.envId).subscribe((data: DocMetadataInfo) => {

            this.groups = data.groups;
            this.docMetadataByGroup = data.docMetadataByGroup;

       }); */
        
    }
    ngOnChanges(changes: SimpleChanges) {

        if ((changes['catVersionId'] && changes['catVersionId'].currentValue != undefined) || (changes['assetType'] && changes['assetType'].currentValue != undefined)) {
            this.docMetadataHandler.getDocMetadataDefinition(this.envId, this.catVersionId, this.lang, this.assetType, this.entityType).subscribe((data: DocMetadataInfo) => {
                this.groups = data.groups;
                this.docMetadataByGroup = data.docMetadataByGroup;
                this.initializedMetadataGroups.emit();
            },
            (err) => {
                console.error('Error fetching document metadata definition:', err);
                this.groups = null;
                this.docMetadataByGroup = null;
                this.initializedMetadataGroups.emit();
            });

        }
    }
    handleDocMetadata(docMetadata: DocMetadata) {
        
        this.docMetadataHandler.handleDocMetadata(docMetadata);
    
    }

    addOrRemoveDocMetadataForGroup(groupName: string, addToGroup: boolean, docMetadata: DocMetadata) {
        if (addToGroup) {
            this.docMetadataHandler.addDocMetadataToGroup(groupName);
        } else {

            this.docMetadataHandler.removeDocMetadataFromGroup(groupName, docMetadata);
        }
    }

    get selections() {

        return this.docMetadataHandler.selections;
    }


    canSubmit() {
        
        if (!this.groups) {
            return false;
        }
        for (let group of this.groups) {
            if (group.isRequired) {
                let selection = this.selections[group.groupName];
                if (!selection || (Array.isArray(selection) && selection.length === 0)) {
                    return false;
                }
            }
        }
        return true;
    }


}